<template>
  <div id="wrapper">
    <Header :isShowFocusMenuType="isShowFocusMenuType"></Header>
    <!--    <Header :isShowFocusMenuType="isShowFocusMenuType" :keywordDataList="keywordDataList"></Header>-->
    <main id="container">
      <div class="cont-wrap">
        <div class="cont-inner">
          <div class="cont-section">
            <!-- 최신자료 -->
            <div class="l">
              <div class = "header-wrap">
                <h3>최신자료</h3>
                <h4 class="more-link" @click="moveToMenu('통계 보고서')">더보기 +</h4>
              </div>
              <div class="swiper data-swiper" style="max-height: 393px;min-height: 393px">
                <swiper class="swiper-wrapper" style="max-height: 291px;min-height: 291px" :options="dataSwiperOption">
                  <swiperSlide v-for="(item, index) in reports" class="swiper-slide" :key="index">
                    <div class="thum-img">
                      <img class="link-cursor" :src="getReportCover(item.imageUrl)" alt="" @error="errorImageHandler" @click="onClickReportHandler(item)">
                    </div>
                    <div class="data-tit link-cursor" style="max-height: 20px;min-height: 20px;text-overflow: ellipsis;text-align: center"
                         @click="onClickReportHandler(item)">{{ item.title }}</div>
                  </swiperSlide>
                </swiper>
                <div class="swiper-btn-prev m-btn"></div>
                <div class="swiper-btn-next m-btn"></div>
                <div class="pc-pagination">
                  <div class="swiper-btn-prev"></div>
                  <div class="swiper-pagination"></div>
                  <div class="swiper-btn-next"></div>
                </div>
              </div>
            </div>
            <!-- // 최신자료 -->

            <!-- 인포그래픽 -->
            <div class="r">
              <div class="swiper chart-swiper" style="height: 448px; display: flex; align-items: center;">
                <swiper
                  v-if="infographics.length > 0"
                  class="swiper-wrapper"
                  :options="infographicSwiperOption"
                  ref="infographicSwiper"
                  style="height: 448px;"
                >
                  <swiperSlide v-for="(item, index) in infographics" class="swiper-slide" :key="index">
                    <img class="infographics" :src="getInfographicCover('/mng' + item.filePath)" alt="" @error="errorImageHandler" @click="onClickInfographicHandler(item)">
                  </swiperSlide>
                </swiper>
                <div class="swiper-button-prev"></div>
                <div class="swiper-button-next"></div>
              </div>
            </div>
            <!-- // 인포그래픽 -->
          </div>
          <div class="cont-section">
            <!-- 분야별 통계 -->
            <div class="l">
              <div class = "header-wrap">
                <h3>분야별 통계</h3>
                <h4 class="more-link" @click="moveToStat()">더보기 +</h4>
              </div>
              <div class="stats-box">
                <div class="main-stats-wrap">
                  <div class="main-stats-list">
                    <div v-for="(item, index) in subjects" class="mn" :key="index">
                      <a href="javascript:void(0)" class="link-cursor" :class="item.subjectId === selectedSubjectId ? 'on' : ''" @click="selectSubject(item.subjectId)">{{ item.name }}</a>
                    </div>
                  </div>
                </div>
                <div class="stats-swiper-wrap">
                  <swiper class="swiper stats-swiper" ref="statsSwiper" :options="StatsSwiperOption">
                    <swiperSlide v-for="(item, index) in level2Subjects" class="swiper-slide" :key="item.id">
                      <a href="javascript:void(0)" @click="onClickLevel2SubjectHandler(item)">{{ item.name }}</a>
                    </swiperSlide>
                  </swiper>
                  <div class="swiper-btn-prev"></div>
                  <div class="swiper-btn-next"></div>
                </div>
              </div>
            </div>
            <!-- // 분야별 통계 -->

            <!-- 공지사항 -->
            <div class="r">
              <div class = "header-wrap">
                <h3>공지사항</h3>
                <h4 class="more-link" @click="moveToMenu('공지사항')">더보기 +</h4>
              </div>
              <div class="main-notice-wrap" style="align-content: center">
                <ul>
                  <li v-for="(item, index) in notices" :key="index">
                    <a href="javascript:void(0)" @click="onClickNoticeHandler(item)">
                      <span class="t">
                        <img v-if="isWithinOneWeek(item.createDate)" src="@/assets/img/ico_new.jpg" style="vertical-align: middle;">&nbsp;
                        {{ item.title }}
                      </span>
                      <span class="date">{{ convertDateFormat(item.createDate) }}</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <!-- // 공지사항 -->
          </div>
        </div>
      </div>
      <Footer></Footer>
    </main>
    <div v-for="(tab, index) in popList" v-bind:key="index">
      <component
        v-bind:is="tab.tabComponent"
        :boardId="tab.boardId"
        :popList="tab.popList"
        :popIndex="index"
        :popTitle="tab.boardTitle"
        :popImg="tab.boardDescription"
        :imgWidth="tab.imgWidth"
        :imgHeight="tab.imgHeight"
        :left=tab.left
        :top=tab.top
        :isDraggable="tab.isDraggable"
        :isImagePopup="tab.isImagePopup"
      ></component>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import axios from 'axios'
import * as noticeApi from '@/api/Notice.js'
import * as logApi from '@/api/Log'
import * as api from '@/api/Menu.js'
import MainPopup from "@/components/popup/MainPopup";
import * as mainApi from '@/api/Main';

export default {
  name: 'Main',
  components: {
    Header,
    Footer,
    swiper,
    swiperSlide,
    MainPopup
  },
  data () {
    return {
      isShowFocusMenuType: false,
      isMobile: false,
      isShowPopupDelay: true,
      infographics: [],
      notices: [],
      reports: [],
      subjects: [
        {subjectId: 'STBL-1014250', name: '문화'},
        {subjectId: 'STBL-1030638', name: '예술'},
        {subjectId: 'STBL-1014252', name: '콘텐츠'},
        {subjectId: 'STBL-1014253', name: '관광'},
        {subjectId: 'STBL-1014255', name: '체육'},
        {subjectId: 'STBL-1030639', name: '종합'},
      ],
      level2Subjects: [],

      selectedSubjectId: '',

      // 인포그래픽 스와이퍼 슬라이더 설정
      infographicSwiperOption: {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        speed: 1000,

        autoplay: {
          delay: 7000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        },

        navigation: {
          nextEl: ".chart-swiper .swiper-button-next",
          prevEl: ".chart-swiper .swiper-button-prev",
        },

        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        watchOverflow: true
      },

      // 최신자료 스와이퍼 슬라이더 설정
      dataSwiperOption: {
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 30,
        //loop: true,
        navigation: {
          nextEl: ".data-swiper .swiper-btn-next",
          prevEl: ".data-swiper .swiper-btn-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        breakpoints: {
          1350: {
            slidesPerView: 3,
            slidesPerGroup: 3,
            spaceBetween: 30,
          },
          768: {
            slidesPerView: 1,
            slidesPerGroup: 1,
          },
        },
      },

      // 분야별 통계 스와이퍼 슬라이더 설정
      StatsSwiperOption: {
        slidesPerView: 3,
        slidesPerColumn: 2,
        slidesPerGroup: 1,
        spaceBetween: 10,
        slidesPerColumnFill: "row",
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: ".stats-swiper-wrap .swiper-btn-next",
          prevEl: ".stats-swiper-wrap .swiper-btn-prev",
        },
        breakpoints: {
          1400: {
            slidesPerView: 2,
            slidesPerColumn: 2,
            spaceBetween: 10,
            slidesPerGroup: 1,
          },
          768: {
            slidesPerView: 2,
            slidesPerColumn: 4,
            spaceBetween: 5,
            slidesPerGroup: 1,
          },
        },
      },
      popList: [],
    }
  },

  mounted() {
    this.isMobile = window.matchMedia('(min-width: 0px) and (max-width: 1125px)').matches;

    this.loadNotices();
    this.loadReports();
    this.loadInfographics();
    this.selectedSubjectId = this.subjects.at().subjectId;

    this.searchPopList(); // 팝업 리스트
  },

  watch: {
    selectedSubjectId: {
      immediate: true,
      handler: async function(val) {
        if (!val) {
          this.level2Subjects.splice(0, this.level2Subjects.length);
          return;
        }


        let items;
        const storeData = this.$store.getters.findSubMenu(val);
        if (storeData) {
          items = storeData.items;
        } else {
          const result = await api.searchMenuSubItems({type: 'STBL', upMgmNo: val });
          items = result.data;
        }

        const upperSubject = this.findSubjectInfoById(val);
        const subjects = items.map(item => {
          return {
            name: item.title,
            statId: item.mgmNo,
            upperName: upperSubject.name,
            upperSubjectId: upperSubject.subjectId
          }
        });

        this.level2Subjects.splice(0, this.level2Subjects.length, ...subjects);
      }
    }
  },

  methods: {
    selectSubject(subjectId) {
      this.selectedSubjectId = subjectId;
    },

    findSubjectInfoById(subjectId) {
      return this.subjects.filter(item => item.subjectId === subjectId).at();
    },

    loadNotices() {
      axios.get(`${process.env.VUE_APP_SERVER}/api/notice/boards/home/list`, {
        params: {count: 5}
      }).then(result => {
        this.notices.splice(0, this.notices.length, ...result.data);
      });
    },

    loadReports() {
      axios.get(`${process.env.VUE_APP_SERVER}/api/statReport/home/list`, {
        params: {count: 20}
      }).then(result => {
        this.reports.splice(0, this.notices.length, ...result.data);
      });
    },

    loadInfographics() {
      this.infographics = []
      axios.get(`${process.env.VUE_APP_SERVER}/api/notice/boards/home/infographics`, {
        params: {}
      }).then(result => {
        this.infographics = this.secureShuffle(result.data || []);
      });
    },

    /**
     * crypto.getRandomValues 기반 Fisher-Yates 셔플 (CWE-330 대응)
     * @param array
     * @returns {Array}
     */
    secureShuffle(array) {
      const arr = [...array];
      const rand = new Uint32Array(1);
      for (let i = arr.length - 1; i > 0; i--) {
        // 모듈로 편향 제거: 균등 분포 범위를 벗어난 값은 재추첨
        const limit = Math.floor(0x100000000 / (i + 1)) * (i + 1);
        let r;
        do {
          window.crypto.getRandomValues(rand);
          r = rand[0];
        } while (r >= limit);
        const j = r % (i + 1);
        [arr[i], arr[j]] = [arr[j], arr[i]];
      }
      return arr;
    },

    /**
     *
     * @param value
     * @returns {boolean}
     */
    isWithinOneWeek(value) {
      if (!value) return false;

      const createDate = new Date(value);
      createDate.setHours(0, 0, 0, 0);

      const oneWeekAgo = new Date();
      oneWeekAgo.setDate(oneWeekAgo.getDate() - 6);
      oneWeekAgo.setHours(0, 0, 0, 0);

      return createDate >= oneWeekAgo;
    },

    /**
     *
     * @param value yyyy-MM-dd
     * @returns {boolean}
     */
    isWithinOneMonth(value) {
      if (!value) return false;
      const createDate = new Date(value);
      const oneMonthAgo = new Date();
      oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
      return createDate >= oneMonthAgo;
    },

    /**
     *
     * @param value yyyy-MM-dd
     * @returns {boolean}
     */
    isTodayByDate(value) {
      const today = new Date().toISOString().slice(0, 10);
      return today === value;
    },

    /**
     * 2000-01-01 -> 2000.00.00
     * @param value yyyy-MM-dd
     */
    convertDateFormat(value) {
      return value.replaceAll('-', '.');
    },

    getReportCover (imageUrl) {
      if (!imageUrl) require('@/assets/img/default_thumbnail.png');
      if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'stag') {
        return imageUrl.replace('/mng/web/mcstmng/source/', 'http://mcst.codedress.co.kr/mng/');
      } else {
        return imageUrl;
      }
    },

    getInfographicCover (imageUrl) {
      if (!imageUrl) require('@/assets/img/default_thumbnail.png');
      if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'stag') {
        return imageUrl.replace('/mng/web/mcstmng/source/', 'http://mcst.codedress.co.kr/mng/');
      } else {
        return imageUrl;
      }
    },

    errorImageHandler(event) {
      event.target.src = require('@/assets/img/default_thumbnail.png');
    },

    /**
     * 최신자료 클릭
     * @param item
     */
    async onClickReportHandler(item) {
      const formData = new FormData();
      formData.append('type', 'STATREPORT')
      formData.append('fileMgmNo', item.attachmentId);
      const statisticsData = await noticeApi.fileConvert(formData);
      const openUrl = statisticsData.data;
      logApi.access(window.location.origin + openUrl);
      window.open(openUrl, '_blank');
    },

    /**
     * 분야별 통계 항목 클릭
     * @param item
     */
    onClickLevel2SubjectHandler(item) {
      this.$router.push({name: item.upperName, params: {
          subItemId: item.statId
        }
      });
    },

    /**
     * 공지사항 클릭
     * @param item
     */
    onClickNoticeHandler(item) {
      if (item.boardType === '000036') {
        //INFO 일반 공지사항
        this.$router.push({name: '공지사항 상세', query: {
            boardId: item.boardId,
            boardType: item.boardType,
            target: '공지사항'
          }
        });
      } else if (item.boardType === '000312') {
        //INFO 대회 공지사항
        this.$router.push({name: '대회 공지사항 상세', query: {
            boardId: item.boardId,
            boardType: item.boardType,
            target: '대회 공지사항'
          }
        });
      }
    },

    onClickInfographicHandler(item) {
      if (item.linkYn === 'Y' && item.linkUrl) {
        window.open(item.linkUrl, '_blank');
      }
    },

    async searchPopList() {
      const popupList = await noticeApi.selectPopBoardList();

      const popupCount = popupList.data.length;
      let baseXY = 5 - (Math.floor((popupCount / 2)) + (popupCount % 2) );

      let idx = 0;
      let popupDataList = [];
      for (const popItem of popupList.data) {
        let imgWidth = 0;
        let imgHeight = 0;
        let isImagePopup = true;

        const boardDesc = popItem.boardDescription;
        const parser = new DOMParser();
        const doc = parser.parseFromString(boardDesc, 'text/html');
        const images = doc.querySelectorAll('img');
        if (images.length > 0) {
          isImagePopup = true;
          images.forEach(image => {
            const width = parseInt(image.style.width);
            const height = parseInt(image.style.height);

            if (imgWidth < width) imgWidth = width;
            if (imgHeight < height) imgHeight = height;
          });
        } else {
          isImagePopup = false;
          imgWidth = 700;
          imgHeight = 450;
        }

        const param = {
          tabComponent: () => import("../components/popup/MainPopup_new"),
          boardId: popItem.boardId,
          popList: popupList.data[idx],
          boardTitle: popItem.boardtitle,
          boardDescription: popItem.boardDescription,
          imgWidth: imgWidth,
          imgHeight: imgHeight + 55 + 35,
          isDraggable: !this.isMobile,
          isImagePopup: isImagePopup,
          left: this.isMobile? 0.5: Number(((baseXY + idx) * 0.1).toFixed(1)),
          top: this.isMobile? 0.5: Number(((baseXY + idx) * 0.1).toFixed(1))
        };

        popupDataList.push(param);
        idx++;
      }

      if (popupDataList.length > 0) {
        this.popList = popupDataList;
      }

    },
    moveToMenu(menuName){
      this.$router.push({name: menuName})
    },
    async moveToStat() {
      // 혹시 아직 DOM 업데이트 안 끝났으면 기다림
      await this.$nextTick();

      if (this.level2Subjects && this.level2Subjects.length > 0) {
        this.onClickLevel2SubjectHandler(this.level2Subjects[0]);
      } else {
        console.warn("level2Subjects 비어있음 (selectedSubjectId 갱신 안 됐을 수 있음)");
      }
    }
  }
}
</script>

<style>
/* 리뉴얼 메인 CSS 추가 */
@import "../assets/css/new_main.css";
@import "../assets/css/new_swiper.min.css";
/* 리뉴얼 메인 CSS 추가 */

.link-cursor {
  cursor: pointer;
}

#app {
  height: 100%;
}
#wrapper {
  height: 100%;
}
.header-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 15px 5px 0px 15px;
}

.header-wrap h4 {
  padding : 10px
}

.more-link {
  font-size: 16px;
  color: #555;
  text-decoration: none;
  cursor: pointer;
}

.more-link:hover {
  text-decoration: underline;
}

.swiper-slide .infographics {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
  cursor: pointer;
}

.data-swiper {
  border: 0;
}

.chart-swiper {
  border: 0;
}
</style>
